export default __webpack_public_path__ + "static/media/deposito.b1ad5252.svg";